"use client";

import { useEffect } from "react";

/**
 * Fires the same phone_number events as <PhoneLink> for plain tel: links
 * inside blog post HTML (which is injected as a string and can't use PhoneLink).
 */
export default function BlogTelTracker() {
  useEffect(() => {
    const handleClick = (e) => {
      const link = e.target.closest?.('.blog-content a[href^="tel:"]');
      if (!link) return;
      if (typeof window.gtag === "function") {
        window.gtag("event", "phone_number", { currency: "USD", value: 50 });
      }
      if (typeof window.uetq?.push === "function") {
        window.uetq.push("event", "phone_number", { revenue_value: 50, currency: "USD" });
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return null;
}
